import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <title>{`${title} | InfluencerCollab`}</title>
      <meta name="description" content={`${title} for InfluencerCollab, the marketplace connecting brands with influencers and UGC creators.`} />
      <div className="grain" />
      <div className="hero-glow absolute top-0 inset-x-0 h-[400px] z-0 pointer-events-none" />

      <header className="relative z-10 border-b border-black/5 bg-background/70 backdrop-blur-2xl">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <Logo />
          <Link to="/" data-testid="legal-home-link" className="text-sm font-semibold text-brand-pink hover:opacity-70">← Back to home</Link>
        </div>
      </header>

      <main className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 py-14">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-pink mb-3">Legal</p>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mb-3">{title}</h1>
        <p className="text-sm text-muted-foreground mb-10">Last updated: {updated}</p>
        <div className="legal-body space-y-7 text-[15px] leading-relaxed text-muted-foreground">
          {children}
        </div>
      </main>

      <footer className="relative z-10 border-t border-black/5 mt-10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-5">
          <Logo size="sm" />
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-foreground">Terms of Service</Link>
          </div>
          <p className="text-xs text-muted-foreground">© 2026 InfluencerCollab.net</p>
        </div>
      </footer>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading font-bold text-xl text-foreground mb-2.5">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
